import { nameReg } from 'utils/functions';
import * as Yup from 'yup';

export const customer_schema = {
  name: '',
  address: '',
  rooms: [],
  stores: [],
};

export const customer_validation_schema = Yup.object({
  name: Yup
    .string()
    .trim()
    .required('Customer name is required')
    .min(3, "Customer name must be of 3 alphabets")
    .matches(nameReg, "Please add valid customer name"),
  address: Yup.string(),
  rooms: Yup.array(),
  stores: Yup.array()
})

